import { createSlice } from "@reduxjs/toolkit";

const predictionSlice = createSlice({
  name: "prediction",
  initialState: {
    // y data stats
    multiFeatures: false,
    detranding: false,
    loadingFeatures: false,
    featuresColumn: [],
    selectedColumn: "",
    modelName: "",
    // main
    mainIndex: [],
    selectedMonthFrom: {},
    selectedMonthTo: {},
    selectedDayFrom: {},
    uploadMaskToggle: false,
    selectedDayTo: {},
    selectedYearFrom: {},
    selectedYearTo: {},
    selectedYearFromCurrent: {},
    selectedYearToCurrent: {},
    spatialStats: {},
    temporalStats: {},
    addedIndexes: [],
    mainPeriodOfTime: [
      {
        label: "By day",
        checked: true,
        key: "same",
      },
      {
        label: "10 Days",
        checked: false,
        key: "days",
      },
      {
        label: "Month",
        checked: false,
        key: "month",
      },
      {
        label: "Range",
        checked: false,
        key: "range",
      },
    ],
    mainTemporalMethod: [
      {
        label: "By pixel",
        checked: false,
        key: "pixel",
      },
      {
        label: "By image",
        checked: true,
        key: "image",
      },
    ],
    // prediction main
    currentAll: [],
    selectedMonthFromCurrent: {},
    selectedMonthToCurrent: {},
    selectedDayFromCurrent: {},
    selectedDayToCurrent: {},
    selectedYearFromCurrent: {},
    selectedYearToCurrent: {},
    addedIndexesCurrent: [],

    // reference
    refToggle: false,
    RefIndex: [],
    selectedRef: {},
    rangePairs: [],
    values: [],
    refFromDate: {},
    refToDate: {},
    refMonthFrom: {},
    refMonthTo: {},
    refDayFrom: {},
    refDayTo: {},
    refYearFrom: {},
    refYearTo: {},
    chooseOneRef: false,

    // predicted ref
    selectedRefPred: {},
    refPredFromDate: {},
    refPredToDate: {},
    refPredIndex: [],
    RefIndexLoadingPred: {},
    monthFromRefPred: {},
    monthToRefPred: {},
    dayFromRefPred: {},
    dayToRefPred: {},
    yearFromRefPred: {},
    yearToRefPred: {},
  },
  reducers: {
    // y data
    setModelName: (state, action) => {
      state.modelName = action.payload;
    },
    setMultiFeature: (state) => {
      state.multiFeatures = !state.multiFeatures;
    },
    setDetranding: (state) => {
      state.detranding = !state.detranding;
    },
    setLoadingfeatures: (state, action) => {
      state.loadingFeatures = action.payload;
    },
    setFeaturesColumn: (state, action) => {
      state.featuresColumn = action.payload;
    },
    setSelectedFeaturesColumn: (state, action) => {
      state.selectedColumn = action.payload;
    },

    // main index
    setMainPeriodOfTime: (state, action) => {
      const index = action.payload;
      const updatedMainPeriodOfTime = state.mainPeriodOfTime.map(
        (item, idx) => ({
          ...item,
          checked: idx === index,
        })
      );
      state.mainPeriodOfTime = updatedMainPeriodOfTime;
    },
    setMainTemporalMethod: (state, action) => {
      const index = action.payload;
      const updatedMainPeriodOfTime = state.mainTemporalMethod.map(
        (item, idx) => ({
          ...item,
          checked: idx === index,
        })
      );
      state.mainTemporalMethod = updatedMainPeriodOfTime;
    },
    setMainIndex: (state, action) => {
      console.log(action.payload);
      state.mainIndex = action.payload;
    },

    setSelectedMonthFrom: (state, action) => {
      state.selectedMonthFrom = action.payload;
    },
    setSelectedMonthTo: (state, action) => {
      state.selectedMonthTo = action.payload;
    },
    setSelectedDayFrom: (state, action) => {
      state.selectedDayFrom = action.payload;
    },
    setSelectedDayTo: (state, action) => {
      state.selectedDayTo = action.payload;
    },
    setSelectedYearFrom: (state, action) => {
      state.selectedYearFrom = action.payload;
    },
    setSelectedYearTo: (state, action) => {
      state.selectedYearTo = action.payload;
    },
    setTemporalStats: (state, action) => {
      const { index, value } = action.payload;
      state.temporalStats = {
        ...state.temporalStats,
        [state.mainIndex[index]]: value,
      };
    },
    setSpatialStats: (state, action) => {
      const { index, value } = action.payload;
      state.spatialStats = {
        ...state.spatialStats,
        [state.mainIndex[index]]: value,
      };
    },

    setAddedIndexesInit: (state, action) => {
      state.addedIndexes = [
        ...state.addedIndexes,
        {
          id: "",
          name: "",
          current_monthFrom: state.selectedMonthFrom,
          current_dayFrom: state.selectedDayFrom,
          current_monthTo: state.selectedMonthTo,
          current_dayTo: state.selectedDayTo,
          current_yearFrom: state.selectedYearFrom,
          current_yearTo: state.selectedYearTo,
          spatialStats: state.spatialStats[state.mainIndex[0]],
          temporalStats: state.temporalStats[state.mainIndex[0]],
          periodOfTime: state.mainPeriodOfTime,
          temporalMethod: state.mainTemporalMethod,
        },
      ];
    },
    setAddedIndexesTemporalMethod: (state, action) => {
      const { index, index2 } = action.payload;
      console.log(index, index2);
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        temporalMethod: updatedIndexes[index2].temporalMethod.map(
          (item, idx) => ({
            ...item,
            checked: idx === index,
          })
        ),
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesPeriodOfTime: (state, action) => {
      const { index, index2 } = action.payload;
      console.log(index, index2);
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        periodOfTime: updatedIndexes[index2].periodOfTime.map((item, idx) => ({
          ...item,
          checked: idx === index,
        })),
      };

      state.addedIndexes = updatedIndexes;
    },
    deleteOneAddIndex: (state, action) => {
      const { index } = action.payload;
      // Create a new array with the item at the specified index removed
      const updatedAddedIndexes = state.addedIndexes.filter(
        (_, i) => i !== index
      );

      // Update the state with the new array
      state.addedIndexes = updatedAddedIndexes;
    },
    setAddedIndexesId: (state, action) => {
      const { index, id } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        id: id,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesName: (state, action) => {
      const { index, name } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        name: name,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesTempStat: (state, action) => {
      const { index, stat } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        temporalStats: stat,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesSpatialStat: (state, action) => {
      const { index, stat } = action.payload;
      console.log("index:::::", index, "stat:::::", stat);

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        spatialStats: stat,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },

    setAddedIndexesmonthFrom: (state, action) => {
      const { index, monthFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the monthFrom property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_monthFrom: monthFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesmonthTo: (state, action) => {
      const { index, monthTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the monthTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_monthTo: monthTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesdayFrom: (state, action) => {
      const { index, dayFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayFrom property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_dayFrom: dayFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesdayTo: (state, action) => {
      const { index, dayTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_dayTo: dayTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesYearTo: (state, action) => {
      const { index, yearTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_yearTo: yearTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesYearFrom: (state, action) => {
      const { index, yearFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_yearFrom: yearFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },

    // prediction main
    setCurrentAll: (state, action) => {
      state.currentAll = action.payload;
    },
    setUploadMaskToggle: (state) => {
      state.uploadMaskToggle = !state.uploadMaskToggle;
    },
    setSelectedMonthFromCurrent: (state, action) => {
      const { index, monthFrom } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        monthFrom: monthFrom,
      };
      state.currentAll = updatedItems;
    },
    setSelectedMonthToCurrent: (state, action) => {
      const { index, monthTo } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        monthTo: monthTo,
      };
      state.currentAll = updatedItems;
    },
    setSelectedDayFromCurrent: (state, action) => {
      const { index, dayFrom } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        dayFrom: dayFrom,
      };
      state.currentAll = updatedItems;
    },
    setSelectedDayToCurrent: (state, action) => {
      const { index, dayTo } = action.payload;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        dayTo: dayTo,
      };
      state.currentAll = updatedItems;
    },
    setSelectedYearFromCurrent: (state, action) => {
      const { index, yearFrom } = action.payload;
      state.selectedYearFromCurrent = yearFrom;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        hist_yearFrom: yearFrom,
      };
      state.currentAll = updatedItems;
    },

    setSelectedYearToCurrent: (state, action) => {
      const { index, yearTo } = action.payload;
      state.selectedYearToCurrent = yearTo;
      const updatedItems = [...state.currentAll];
      updatedItems[index] = {
        ...updatedItems[index],
        hist_yearTo: yearTo,
      };
      state.currentAll = updatedItems;
    },
    // -----------
    // -------------------------
    // ---------------------------------------
    // reference index
    setChooseOneRef: (state) => {
      state.chooseOneRef = !state.chooseOneRef;
    },
    setRefIndex: (state, action) => {
      state.RefIndex = action.payload;
    },

    setRefMonthFrom: (state, action) => {
      state.refMonthFrom = action.payload;
    },
    setRefMonthTo: (state, action) => {
      state.refMonthTo = action.payload;
    },
    setRefDayFrom: (state, action) => {
      state.refDayFrom = action.payload;
    },
    setRefDayTo: (state, action) => {
      state.refDayTo = action.payload;
    },
    setRefYearFrom: (state, action) => {
      state.refYearFrom = action.payload;
    },

    setRefYearTo: (state, action) => {
      state.refYearTo = action.payload;
    },
    setSelectedRef: (state, action) => {
      const { index, path } = action.payload;
      console.log(path);
      state.selectedRef = {
        ...state.selectedRef,
        [state.RefIndex[index]]: [path],
      };
    },
    setRangePairs: (state, action) => {
      state.rangePairs = action.payload;
    },
    setValues: (state, action) => {
      state.values = action.payload;
    },
    setRefToggle: (state) => {
      state.refToggle = !state.refToggle;
    },
    setRefFromDate: (state, action) => {
      state.refFromDate = action.payload;
    },
    setRefToDate: (state, action) => {
      state.refToDate = action.payload;
    },
    setRefPredIndex: (state, action) => {
      state.refPredIndex = action.payload;
    },
    setRefPredFromDate: (state, action) => {
      state.refPredFromDate = action.payload;
    },
    setRefPredToDate: (state, action) => {
      state.refPredToDate = action.payload;
    },
    clearRefDates: (state) => {
      state.refFromDate = "";
      state.refToDate = "";
    },
    clearRefPredDates: (state) => {
      state.refPredFromDate = "";
      state.refPredToDate = "";
    },
    // Ref index Predict

    setSelectedMonthFromRefPred: (state, action) => {
      state.monthFromRefPred = action.payload;
    },
    setSelectedMonthToRefPred: (state, action) => {
      state.monthToRefPred = action.payload;
    },
    setSelectedDayFromRefPred: (state, action) => {
      state.dayFromRefPred = action.payload;
    },
    setSelectedDayToRefPred: (state, action) => {
      state.dayToRefPred = action.payload;
    },
    setSelectedYearFromRefPred: (state, action) => {
      state.yearFromRefPred = action.payload;
    },

    setSelectedYearToRefPred: (state, action) => {
      state.yearToRefPred = action.payload;
    },

    setRefIndexLoadingInitPred: (state, action) => {
      state.RefIndexLoadingPred = action.payload;
    },
    setRefIndexLoadingPred: (state, action) => {
      const newState = [...state.RefIndexLoadingPred]; // Create a copy of the current state array
      newState[action.payload] = !newState[action.payload]; // Toggle the value at the specified index
      state.RefIndexLoadingPred = newState;
    },

    setSelectedRefPred: (state, action) => {
      console.log(action.payload);
      const { index, path } = action.payload;
      state.selectedRefPred = {
        ...state.selectedRefPred,
        [state.RefIndex[index]]: path,
      };
    },
  },
});

export const {
  // y data
  setDetranding,
  setMultiFeature,
  setFeaturesColumn,
  setLoadingfeatures,
  setSelectedFeaturesColumn,
  setModelName,
  // main index
  setAddedIndexesTemporalMethod,
  setMainTemporalMethod,
  setAddedIndexesPeriodOfTime,
  setMainPeriodOfTime,
  setAddedIndexesSpatialStat,
  setAddedIndexesTempStat,
  setSpatialStats,
  setTemporalStats,
  deleteOneAddIndex,
  setAddedIndexesId,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  setAddedIndexesdayFrom,
  setAddedIndexesdayTo,
  setAddedIndexesmonthFrom,
  setAddedIndexesmonthTo,
  setSelectedDayFrom,
  setSelectedDayTo,
  setSelectedMonthFrom,
  setSelectedMonthTo,
  setSelectedYearFrom,
  setSelectedYearTo,
  cleatSelectionMain,
  setSelectedMainByMonth,
  setMainIndex,
  setAddedIndexesInit,
  setAddedIndexesName,
  // ref index
  setChooseOneRef,
  setRangePairs,
  setRefDayFrom,
  setRefDayTo,
  setRefIndex,
  setRefMonthFrom,
  setRefMonthTo,
  setRefToggle,
  setRefYearFrom,
  setRefYearTo,
  setSelectedRef,
  setValues,

  //pred indexes
  setCurrentAll,
  setSelectedDayFromCurrent,
  setSelectedDayToCurrent,
  setSelectedMonthFromCurrent,
  setSelectedMonthToCurrent,
  setSelectedYearFromCurrent,
  setSelectedYearToCurrent,

  // predicted ref
  setRefIndexLoadingInitPred,
  setRefIndexLoadingPred,
  setSelectedDayFromRefPred,
  setSelectedDayToRefPred,
  setSelectedMonthFromRefPred,
  setSelectedMonthToRefPred,
  setSelectedRefPred,
  setSelectedYearFromRefPred,
  setSelectedYearToRefPred,
  setRefFromDate,
  setRefToDate,
  clearRefDates,
  clearRefPredDates,
  setUploadMaskToggle,
  setRefPredToDate,
  setRefPredFromDate,
  setRefPredIndex,
} = predictionSlice.actions;

export default predictionSlice.reducer;
